/* eslint-disable */
/** 校验账号 */
let checkUsername = function (val) {
  // let reg = /^(\w){8,16}$/
  let reg = /^(?=^.*?\d)(?=^.*?[a-zA-Z])^[0-9a-zA-Z]{6,12}$/;
  let mobile = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
  if (val === '') {
    return '请输入账号';
  }
  else if (!reg.test(val) || val.length < 6) {
    return '账号由6-12位组成，需包含英文、数字并且字母开头';
  }
  // else if (mobile.test(val)) {
  //   return '账号不能为手机号';
  // }
  return '';
};
let checkUsername26 = function (val) {
  // let reg = /^(\w){8,16}$/
  let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/
  let mobile = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
  if (val === '') {
    return '请输入账号';
  }
  // else if (!reg.test(val) || val.length < 6) {
  //   return '账号由6-12位组成，需包含英文、数字并且字母开头';
  // }
  // else if (mobile.test(val)) {
  //   return '账号不能为手机号';
  // }
  return '';
};
let checkUsername33 = function (val) {
  let reg = /^[a-zA-Z0-9]{6,16}$/;
  let mobile = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
  if (val === '') {
    return '请输入账号';
  }
  else if (!reg.test(val) || val.length < 6) {
    return '账号由6-16位英文或数字组成';
  }
  // else if (mobile.test(val)) {
  //   return '账号不能为手机号';
  // }
  return '';
};
let checkUsername39 = function (val) {
  let reg = /^[A-Za-z]{1}[A-Za-z0-9]{5,12}$/
  if (val === '') {
    return '请输入账号';
  }
  else if (!reg.test(val) || val.length < 6) {
    return '账号6-12位字母、数字组成，并以字母开头';
  }
  // else if (mobile.test(val)) {
  //   return '账号不能为手机号';
  // }
  return '';
};
/** 校验账号03B */
let checkUsername42 = function (val) {
  // let reg = /^(\w){8,16}$/
  // let reg = /^(?=^.*?\d)(?=^.*?[a-zA-Z])^[0-9a-zA-Z]{6,12}$/;
  let reg = /^[0-9a-zA-Z]{6,12}$/
  let mobile = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
  if (val === '') {
    return '请输入账号';
  }
  else if (!reg.test(val) || val.length < 6) {
    return '账号由6-12位字母或数字组成';
  }
  else if (mobile.test(val)) {
    return '账号不能为手机号';
  }
  return '';
};
let checkRegisterUsername = function(val) {
  let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/
  if (val === '') {
    return '请输入账号';
  }else if(!reg.test(val)){
    return '账号由6-12位组成，需包含英文、数字并且字母开头';
  }
}
let checkRegisterUsername26 = function(val) {
  let reg =/^[a-zA-Z][a-zA-Z0-9]{5,11}$/
  if (val === '') {
    return '请输入账号';
  }else if(!reg.test(val)){
    return '6-12位字符，字母开头，限字母、数字';
  }
}
/**校验手机号*/
let checkPhone = function (val) {
  // let mobile = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
  let mobile = /^1\d{10}$/;
  if(val===''){
    return '请输入手机号'
  }else if(!mobile.test(val)){
    return '请输入正确的手机号'
  }

  return ''
};
/**验证多国手机号*/
let checkPhoneNumber = function(val) {
  let reg = /^\d+$/;
  if (!reg.test(val)) {
    return '请输入正确的手机号'
  }else if(val==='') {
    return '请输入手机号'
  }
  return '';
}
/**验证小数*/
let checkLittle = function(val) {
  let reg = /^([0-9]{1,}[.][0-9]*)$/;
  if (reg.test(val)) {
    return '该平台暂不支持小数转账'
  }
  return '';
};
/**校验数字--正整数*/
let checkNumber = function (val) {
  let reg = /^\+?[1-9][0-9]*$/;
  if (val === '') {
    return '请输入金额';
  } else if (!reg.test(val)) {
    return '金额格式错误，请输入正整数';
  }else if(val == 0){
    return '金额不能为0';
  }
  return ''
};
/** 校验登录密码 */
let checkLoginPassword = function (val) {
  // let reg = /^[0-9a-zA-Z!@#%$*&^.~_)(}{|;:=+<>]{6,12}$/;

  if (val === '') {
    return '请输入密码';
  }
  // else if (!reg.test(val)) {
  //   return '密码由6-12位大小写英文字母、0-9和部分特殊符号组成'
  // }
  return '';
};
/** 校验密码 */
let checkPassword = function (val) {
  // let reg = /^[0-9a-zA-Z!@#%$*&^.~_)(}{|;:=+<>]{6,12}$/;

  if (val === '') {
    return 'Please enter password';
  }
  // else if (!reg.test(val)) {
  //   return '密码由6-12位大小写英文字母、0-9和部分特殊符号组成'
  // }
  return '';
};
/** 校验万豪手机号登录验证码 */
let checkLoginPhone = function (val) {
  // let reg = /^[0-9a-zA-Z!@#%$*&^.~_)(}{|;:=+<>]{6,12}$/;

  if (val === '') {
    return '请输入验证码或密码';
  }
  // else if (!reg.test(val)) {
  //   return '密码由6-12位大小写英文字母、0-9和部分特殊符号组成'
  // }
  return '';
};
let checkRegisterPassword = function(val) {
   let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/;

   if (val === '') {
    return '请输入密码';
  }
  else if (!reg.test(val)) {
    return '密码由6-12位大小写英文字母和数字组成'
  }
  return '';
}
let checkRegisterPassword26 = function(val) {
  let reg =/^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6,}$/;

  if (val === '') {
   return '请输入密码';
 }else if (!reg.test(val)) {
   return '6个字符以上，须包含字母及数字'
 }
 return '';
}
/** 提款密码 */
let checkWithdraw = function (val) {

  // let reg = /^(?![0-9A-Z]+$)(?![0-9a-z]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,15}$/;
  if (val === '') {
    return '请输入取款密码';
  }else if(val.length < 4 ){
    return '请输入至少4位数的取款密码';
  }
  // else if (!reg.test(val)) {
  //   return '提款密码由8-15位大小写英文字母、0-9组成'
  // }
  return '';
};
/** 校验确认密码 */
let checkConfirm = function (p1, p2) {
  if (p2 === '') {
    return '请再次输入密码';
  } else if (p2 !== p1) {
    return '两次密码输入不一致';
  }
  return '';
}
/** 校验原密码确认密码 */
let checkConfirms = function (p1, p2) {
  if (p2 === p1) {
    return '新密码与原密码相同';
  }
  return '';
}
let checkOldPassword = function (val) {
  if (val === '') {
    this.toast('请输入旧密码');
  }
  return '';
}
/** 校验账号 */
let checkNickname = function (val) {
  let reg = /^[0-9a-zA-Z!@#%$*&^.~_)(}{|;:=+<>\u4e00-\u9fa5]{2,8}$/
  let mobile = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/
  if (val === '') {
    return '请输入昵称';
  } else if (!reg.test(val)) {
    return '昵称由2-8字符/中文组成';
  } else if (mobile.test(val)) {
    return '昵称不能为手机号';
  }
  return '';
};
/** 校验 */
let checkRealname = function (val) {
  // let reg = /^[a-zA-Z\u4e00-\u9fa5]{2,10}$/
  // let reg = /^[^0-9]{6,}$/
  if (val === '') {
    return '请输入真实姓名';
  }
  // else if(!reg.test(val.trim())){
  //   return '请输入真实姓名';
  // }
  // else if (!reg.test(val)) {
  //   return '真实姓名格式错误';
  // }
  return '';
};
/** 校验开户行 */
let checkOpenType = function (val) {
  let reg = /^[a-zA-Z\u4e00-\u9fa5]{2,10}$/
  // let reg = /^[\u4e00-\u9fa5]{2,20}$/
  if (val === '') {
    return '请输入开户支行类型';
  } else if (!reg.test(val)) {
    return '请勿输入特殊字符';
  }
  return '';
};
/** 校验支行*/
let checkBranch = function (val) {
  let reg = /^[a-zA-Z\u4e00-\u9fa5]{1,20}$/
  if (val === '') {
    return '请输入开户支行';
  } else if (!reg.test(val)) {
    return '开户支行格式错误';
  }
  return '';
};
/** 校验邮箱 */
let checkEmail = function (val) {
  let reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
  if (val === '') {
    return '请输入邮箱';
  } else if (!reg.test(val)) {
    return '邮箱格式错误';
  }
  return '';
};
/* 校验qq */
let checkqq = function(val){
  let reg = /^[1-9][0-9]{4,9}$/g;
  if (val === '') {
    return '请输入QQ';
  } else if (!reg.test(val)) {
    return 'QQ格式错误';
  }
  return '';
}
let checkwechat = function(val){
  let reg = /^[a-zA-Z][a-zA-Z\d_-]{5,19}$/;
  if (val === '') {
    return '请输入微信';
  } else if (!reg.test(val)) {
    return '微信格式错误';
  }
  return '';
}
/** 校验身份证 */
let checkCard = function (val) {
  let reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/;
  if (val === '') {
    return '请输入身份证号';
  } else if (!reg.test(val)) {
    return '身份证格式错误';
  }
  return '';
};
/** 校验金额 */
let checkMoney = function (val) {
  // let reg = /(^[1-9]([0-9]+)?(\.[0-9]*)?$)|(^(0){1}$)|(^(0){1}\.[0-9]+$)/;
  let reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^0$)|(^\d\.\d{1,2}$)/;
  if (val === '') {
    return '请输入金额';
  } else if (!reg.test(val)) {
    return '金额格式错误';
  }else if(val == 0){
    return '金额不能为0';
  }
  return ''
};
/** 校验支付金额*/ 
let checkPayMoney = function(val,min,max){
  let reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^0$)|(^\d\.\d{1,2}$)/;
  if (val === '') {
    return '请输入金额';
  } else if (!reg.test(val)) {
    return '金额格式错误';
  }else if(!(min <= val && val <= max)){
    return `存款限额：${min}-${max}元`;
  }
  return ''
}
/**校验银行卡*/
let checkBankNumber = function (val) {

  let reg = /^([1-9]{1})(\d{14}|\d{18}|\d{17}|\d{15})$/;
  if (val === '') {
    return '请输入银行卡号';
  } else if (!reg.test(val)) {
    return '银行卡号格式错误';
  }
  return ''
};
/**校验验证码*/
let checkVerifiCode = function (val) {

  let reg = /^[0-9]{4,8}$/;
  if (val === '') {
    return '验证码不能为空';
  } else if (!reg.test(val)) {
    return '验证码格式错误';
  }
  return ''
};

/** 校验注单号*/
let checkBisNumber=(val)=>{
  if(val === ''){
    return '注单号不能为空';
  }
}

/** 校验平台key*/
let checkPlatformKey=(val)=>{
  if(val === ''){
    return '平台号不能为空';
  }
}

export default {
  checkUsername: checkUsername,
  checkPassword: checkPassword,
  checkRegisterPassword:checkRegisterPassword,
  checkLoginPassword: checkLoginPassword,
  checkConfirm: checkConfirm,
  checkOldPassword: checkOldPassword,
  checkConfirms: checkConfirms,
  checkNickname: checkNickname,
  checkRealname: checkRealname,
  checkPhone: checkPhone,
  checkEmail: checkEmail,
  checkqq,
  checkLoginPhone,
  checkwechat,
  checkCard: checkCard,
  checkMoney: checkMoney,
  checkPayMoney,
  checkBankNumber: checkBankNumber,
  checkWithdraw: checkWithdraw,
  checkVerifiCode: checkVerifiCode,
  checkOpenType: checkOpenType,
  checkBranch: checkBranch,
  checkLittle: checkLittle,
  checkNumber: checkNumber,
  checkPhoneNumber,
  checkBisNumber,
  checkPlatformKey,
  checkRegisterUsername,
  checkRegisterUsername26,
  checkRegisterPassword26:checkRegisterPassword26,
  checkUsername26: checkUsername26,
  checkUsername42: checkUsername42,
  checkUsername33: checkUsername33,
  checkUsername39: checkUsername39,
};



// WEBPACK FOOTER //
// ./src/common/form/index.js